import Home from '@/views/Home/Chinese/Home.vue'
// import Super_yachts from "@/views/Super_yachts/Chinese/Super_yachts.vue"
// import Water_sports from "@/views/Water_sports/Chinese/Water_sports.vue"
// import Fishing from "@/views/Fishing/Chinese/Fishing"
import Tours from '@/views/Tours/Chinese/Tours.vue'
// import Terms from '@/views/Terms/Chinese/Terms.vue';
// import Policy from '@/views/Policy/Chinese/Policy.vue';
// import Company from "@/views/Company/Chinese/Company.vue"
// import News from "@/views/News/Chinese/News.vue"
// import Office from "@/views/Office/Chinese/Office"
import Fun from '@/views/Fun/Chinese/Fun.vue'
// 中文语言路由表
export default [
    // {
    //     path: '/chinese/home',
    //     component: Home,
    // },
    {
        path: '/chinese/yachtTours',
        component: () => import('@/views/Tours/Chinese/Tours.vue'),
    },
    {
        path: '/chinese/superYachts',
        component: () => import('@/views/Super_yachts/Chinese/Super_yachts.vue'),
    },
    {
        path: '/chinese/waterSports',
        component: () => import('@/views/Water_sports/Chinese/teach.vue'),
    },
    {
        path: '/chinese/news',
        component: () => import('@/views/News/Chinese/News.vue'),
        children: [
            {
                path: '',
                component: () => import('@/views/News/Chinese/defaultPage.vue'),
                meta: { detail: true },
            },
            {
                path: 'detail',
                component: () => import('@/views/News/Chinese/newsDetail.vue'),
                meta: { detail: true },
            },
        ],
    },
    {
        path: '/chinese/contact',
        component: () => import('@/views/Office/Chinese/Office'),
    },
    {
        path: '/chinese/bookOrder',
        component: () => import('@/views/Fun/Chinese/Fun.vue'),
    },
    {
        path: '/chinese/fishing',
        component: () => import('@/views/Fishing/Chinese/Fishing'),
    },
    // {
    //   path: '/chinese/Policy',
    //   component: Policy,
    // },
    // {
    //   path: '/chinese/terms',
    //   component: Terms,
    // },
    {
        path: '/chinese/team',
        component: () => import('@/views/Company/Chinese/Company.vue'),
    },
    // {
    //     path: '/chinese/OrderManagement',
    //     redirect: '/chinese/OrderManagement/QuickOrder',
    //     component: () => import('@/views/OrderManagement/Chinese'),
    //     children: [
    //         {
    //             path: 'QuickOrder',
    //             name: 'CQuickOrder',
    //             component: () => import('@/views/OrderManagement/Chinese/QuickOrder'),
    //             meta: {
    //                 name: 'quickOrder',
    //             },
    //         },
    //         {
    //             path: 'Management',
    //             name: 'CManagement',
    //             component: () => import('@/views/OrderManagement/Chinese/Management'),
    //             meta: {
    //                 name: 'Management',
    //             },
    //         },
    //     ],
    // },
    // {
    //     path: '/english/OrderManagement/CharterOrder',
    //     name: 'ECharterOrder',
    //     component: () => import('@/views/OrderManagement/Charter/quickOrder'),
    //     // component: () => import("@/views/OrderManagement/English/QuickOrder"),
    //     meta: {
    //         name: 'CharterOrder',
    //     },
    // },
]
